export default __webpack_public_path__ + "static/media/LieselotteLovelace.ed01cc47.png";